<template>
    <div class="mesh-deformation" :class="{ show: isShowDeformationEditor }">
      <div class="mesh-deformation-view">
        <div class="card mesh-deformation-info border-0 text-left w-auto">
          <h5 class="text-color text-size fw-semibold mb-2">{{ newProductTitle }}</h5>
          <table class="fw-normal text-muted">
            <tbody v-if="orderData && !orderData?.fields">
              <tr>
                <td>{{ $t('components.order-form.height') }}</td>
                <td>: {{ orderData.heightWithoutDeduction }}</td>
              </tr>
              <tr>
                <td>{{ $t('components.order-form.scope-top') }}</td>
                <td>: {{ orderData.depth }}</td>
              </tr>
              <tr>
                <td>{{ selectedModel?.product?.name?.toLowerCase().includes('prothesenschaft')
                        ? $t('components.order-form.scope-bottom-prothesenschaft')
                        : $t('components.order-form.scope-bottom') }}</td>
                <td>: {{ orderData.calfCircumferenceWithoutDeduction }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <!-- <div v-for="(field, index) in product.fields" :key="field.id" :class="getFieldClass(field, index)"></div> -->
              <tr v-for="field in orderData?.fields" :key="field.id">
                <td>
                  <span class="text-capitalize">{{ field.label }}</span>
                </td>
                <td>: {{ field.value }} %</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mesh-deformation-title">
          <h5 v-if="!isLoadingDeformation" class="text-color text-size fw-semibold mb-2">
            {{ $t('components.mesh-editor.deformationResult') }}
          </h5>
          <h5 v-else class="text-color text-size fw-semibold mb-2">
            {{ $t('components.mesh-editor.deformationProgress') }}
          </h5>
        </div>
        <div v-loading="isLoadingDeformation" element-loading-background="transparent" class="mesh-deformation-progress"></div>
        <mesh-editor
          ref="meshEditor"
          v-model="selectedProductInput"
          :can-toggle-pivot-mode="false"
          :can-select="[1, 2, 3].includes(this.workflowModel.active)"
          :can-toggle-bones="false"
          :can-deform="false"
          :can-curve="false"
          :activate-aline-to-floor="false"
          :activate-bones="false"
          :active-editor-mode="false"
          :activate-display-bounding-box="false"
          :reset-on-pivot-changed="true"
          :fit-camera-to-scene="true"
          :can-undo="false"
          :can-part-select="false"
          :can-toggle-opacity="true"
          :has-navigation-bar="true"
          :can-xr="true"
          :show-siderbar-right-tools="true"
          :is-loading-download-object="isLoadingDownloadObject"
          :is-show-deformation-editor="isShowDeformationEditor"
          :is-deformation-active="isDeformationActive"
          :is-loading-deformation="isLoadingDeformation"
          @meshes-loaded="$emit('meshesLoaded')"
          @download3-d-file-to-obj="(sceneRef: any) => $emit('download3DFileToObj', sceneRef)"
          @show-product-parameter-modal-dialog="$emit('showProductParameterModalDialog', selectedModel, true)"
          @close-deformation-editor="$emit('closeDeformationEditor')"
        />
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { Component, Vue, Prop } from 'vue-facing-decorator';
  import { ref } from 'vue';
  
  import { MeshTreeData } from '@/types/ui/MeshTreeData';
  import { CustomizeProgress } from '@/types/enum/workflow';
  import MeshEditor from './MeshEditor.vue';
  import { Model2 } from '@/types/api/Model/Model';
  import { NewOrderData } from './MeshLoader.vue';
  import { removeWordFromString } from '@/utils/formBuilder';
  import { WorkflowModel } from '@/types/ui/WorkflowModel';
  import TextLoading from '@/components/ui-elements/TextLoading.vue';
  
  @Component({
    methods: { ref },
    components: { MeshEditor, TextLoading },
    emits: ['meshesLoaded', 'download3DFileToObj', 'showProductParameterModalDialog', 'closeDeformationEditor'],
  })
  
  export default class MeshDeformationEditor extends Vue {
    @Prop({ default: false }) isShowDeformationEditor!: boolean;
    @Prop({ default: false }) isLoadingDeformation!: boolean;
    @Prop({ default: false }) isLoadingDownloadObject!: boolean;
    @Prop({ default: false }) isDeformationActive!: boolean;
    @Prop({ default: 'Title' }) productTitle!: string;
    @Prop() orderData!: NewOrderData;
    @Prop() selectedProductInput!: MeshTreeData;
    @Prop() workflowModel!: WorkflowModel<CustomizeProgress>;
    @Prop() selectedModel!: Model2 | null;
  
    get newProductTitle(): string {
      return removeWordFromString(removeWordFromString(this.productTitle, 'phase1'), 'withdeformation');
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .mesh-deformation.show {
    visibility: visible !important;
  }
  .mesh-deformation {
    visibility: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    bottom: 0;
    top: 0;
    z-index: 100 !important;
    background-color: #00000066;
    //padding: 40px 70px;
  }
  .mesh-deformation-view {
    overflow: hidden; /* Menghilangkan scroll */
    position: relative;
    min-height: 100%;
    background-color: #fff;
    // border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    //max-width: 90%; /* Batas maksimum lebar */
    //max-height: 90%; /* Batas maksimum tinggi */
    margin: auto; /* Memastikan elemen tetap di tengah */
    flex: 1;
  }
  .mesh-deformation-info {
    // padding: ;
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 101 !important;
    border-color: transparent;
    padding: 20px;
    text-align: left !important;
    min-width: 240px;
  }
  .mesh-deformation-title {
    position: absolute;
    left: 20px;
    bottom: 20px;
    z-index: 101 !important;
  }
  .mesh-deformation-progress {
    position: absolute;
    z-index: 101 !important;
    width: 100px !important;
    height: 100px !important;
    border-radius: 10px !important;
    background-color: transparent !important;
  }
  </style>